import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { FeedstockService } from '../../../services/feedstockservice';
import { UserGridColumnPreferenceRequest } from '../../../interfaces/feedstocklistmodel';
import { MatIconModule } from '@angular/material/icon';
import { DragDropModule } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-column-selector',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatListModule,
    MatButtonModule,
    MatIconModule,
    DragDropModule
  ],
  templateUrl: './column-selector.component.html'
})
export class ColumnSelectorComponent implements OnInit {

  selectedColumns: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ColumnSelectorComponent>,
    private feedstockService: FeedstockService
  ) { }

  ngOnInit(): void {
    this.selectedColumns = [...this.data.selectedColumns];
    this.loadColumnPreferences();
  }

  private loadColumnPreferences(): void {

    this.feedstockService
      .getUserGridColumnPreferences(this.data.gridId)
      .subscribe({
        next: (response: any) => {

          if (response?.columnsJson) {
            this.selectedColumns = JSON.parse(response.columnsJson);
          }
        },
        error: () => {
          // Ignore and use default columns
        }
      });
  }

  saveColumns(): void {

    const request: UserGridColumnPreferenceRequest = {
      gridId: 1,
      columnsJson: JSON.stringify(this.selectedColumns)
    };

    this.feedstockService
      .saveUserGridColumnPreferences(request)
      .subscribe({
        next: () => {
          this.dialogRef.close(this.selectedColumns);
        }
      });
  }
  onClose(): void {
    this.dialogRef.close(false);
  }
}
